module.exports = __webpack_public_path__ + "static/img/online.1f1503b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collection/online.png
// module id = Lcp3
// module chunks = 1